module.exports = __webpack_public_path__ + "media/images/icons/outlined/aliyun-03957556f490d032b8207e4e675cebd6.svg";